/**
 * The VAS (visual analogue scale) severity bands shared by the medical-history
 * sections. Colours read exactly from the Chief complaints table (Figma
 * 2441:6282) via Dev Mode MCP. A score maps to the band whose range contains it.
 *
 * 0 = Absent/Resolved · 1–3 Mild · 4–6 Moderate · 7–9 Severe · 10 Worst.
 */
export const VAS_BANDS = [
  { key: "absent", label: "Resolved", min: 0, max: 0, bg: "#f3f4f6", fg: "#4a5565", dot: "#8a94a6" },
  { key: "mild", label: "Mild (1-3)", min: 1, max: 3, bg: "#d1fae5", fg: "#065f46", dot: "#10b981" },
  { key: "moderate", label: "Moderate (4-6)", min: 4, max: 6, bg: "#fef3c7", fg: "#92400e", dot: "#f59e0b" },
  { key: "severe", label: "Severe (7-9)", min: 7, max: 9, bg: "#ffedd5", fg: "#f97316", dot: "#f97316" },
  { key: "worst", label: "Worst (10)", min: 10, max: 10, bg: "#fee2e2", fg: "#9b1c1c", dot: "#eb5757" },
];

export const vasBand = (score) =>
  VAS_BANDS.find((b) => score >= b.min && score <= b.max) || VAS_BANDS[0];
